<template>
  <span class="pictureCircle">
    <span class="pictureCircle__wrapper">
      <img
        v-if="src || !fallback"
        :src="src"
        v-bind="$attrs"
        class="pictureCircle__image"
      />
      <img
        v-else
        class="pictureCircle__image fallback"
        :src="ThumbPerson"
        v-bind="$attrs"
      />
    </span>
  </span>
</template>

<script>
import ThumbPerson from '@/assets/thumb-person.png';

export default {
  name: 'PictureCircle',

  props: {
    src: {
      type: String,
      default: null,
    },
    fallback: {
      type: Boolean,
      default: true,
    },
  },

  data: () => ({
    ThumbPerson,
  }),
};
</script>

<style lang="scss" scoped>
.pictureCircle {
  width: 40px;
  position: relative;
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;
  flex-basis: auto;
  background: $gray_main;

  &__wrapper {
    position: relative;
    display: flex;
    padding-bottom: 100%;
  }

  &__image {
    object-fit: cover;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;

    .fallback {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      background: $gray_main;
    }
  }
}
</style>
